import { useEffect } from 'react';
import { useAuth } from '@features/auth/context/AuthContext';
import { useTenantShops } from '@core/tenant/TenantShopsContext';
import { setEventSdkUserId } from '@core/events';

/** Keeps event SDK user id in sync with Firebase / shop customer rows. */
export function EventSdkUserSync() {
  const { user, getUserForShop } = useAuth();
  const { shops } = useTenantShops();

  useEffect(() => {
    if (!user) {
      setEventSdkUserId(undefined);
      return;
    }

    const primaryShopId = shops[0]?.id;
    const userId = primaryShopId ? getUserForShop(primaryShopId)?.id : undefined;
    setEventSdkUserId(userId);
  }, [getUserForShop, user, shops]);

  return null;
}
